module.exports = __webpack_public_path__ + "img/gerenzhongxin.a472d7ef.png";